import { render, staticRenderFns } from "./ProductBrowser.vue?vue&type=template&id=54a4af15&scoped=true"
import script from "./ProductBrowser.vue?vue&type=script&lang=js"
export * from "./ProductBrowser.vue?vue&type=script&lang=js"
import style0 from "./ProductBrowser.vue?vue&type=style&index=0&id=54a4af15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4af15",
  null
  
)

export default component.exports